const trackingUtils = require('od-modules/utils/tracking.utils');
const tagManagement = require('../modules/utils/tag_management.utils');
const postBookingEventController = require('../modules/handlers/post_booking');
const postBookingUtils = require('../modules/utils/post_booking.utils');
const myTripsUtils = require('../modules/utils/my_trips.utils');
const tripdetailsStorageUtils = require('../modules/utils/tripdetails_storage.utils');
const ssoUtils = require('../modules/utils/sso.utils');
const xsellFindBookingFactory = require('components/cross_selling/find_booking/js/main');
const createWidgetLoader = require('components-framework/widget/create_widget_loader');
const myTripsFactory = require('components/user_area/my_trips/js/main');
const checkinStatusFactory = require('components/checkin/checkin_status/js/main');
const checkinMoreinfoFactory = require('components/checkin/checkin_moreinfo/js/main');
const checkinErrorFactory = require('components/checkin/checkin_error/js/main');
const pbAncillariesCollection = require('od-modules/collections/pb_ancillaries_collection/collection');
const itineraryStatusTracking = require('../tracking/itinerary_status');
const manageMyBookingModule = require('od-modules/manage_my_booking/manage_my_booking');
const getFrontendBookingManagement = () => import('@edreamsodigeo/frontend-booking-management');

const BOOKING_FLOW_DEFAULT_DELAY = 1000;
const TRIPDETAILS = 'tripdetails';
const MANAGE_MY_BOOKING = 'managemybooking';
const BOOKING_INFO = 'bookingInfo';
const REFRESH_GENERAL_STATUS_TIME = Odigeo.UIElements.translations.generalStatusRefresh.tripDetailsRefresh;
let autoRefreshTimeout;

Odigeo.Router.handlers.tripdetails = function(params) {
    const $page = $('#page');
    const $personalAreaMenu = $('#personal_area_menu');
    const $loggedMenu = $personalAreaMenu.find('.pa_menu_logged');
    const $notLoggedMenu = $personalAreaMenu.find('.pa_menu_not_logged');
    const $manageMyBookingBox = $('.manage_my_booking_menu');
    const urlParams = Odigeo._.defaults({}, Odigeo.Utils.parseHashParameters(params), {showFlightInfo: false});
    const {td: deeplinkToken, tdo: deeplinkTokenOld, actions, product, funnel} = urlParams;
    const {origin: deeplinkOrigin} = Odigeo.Utils.decodeParams(window.location.search.substring(1));
    const widgets = Odigeo.autoloadWidgetsAsync({
        getUsersManager: ['users-manager', 'usersmanager'],
        getPostBookingBags: ['post-booking-bags', 'post_booking_bags'],
        getPostBookingSeats: ['post-booking-seats', 'post_booking_seats'],
    });
    const ancillaryInfo = Odigeo.Session.get('ancillaryInfo');
    let bookingInfo = Odigeo.Utils.parseJson(Odigeo.Session.get(BOOKING_INFO));
    const isValidBookingInfo = bookingInfo && !bookingInfo.forceReload && tripdetailsStorageUtils.isKeyAndExpirationTimeValid(BOOKING_INFO);
    const isHSABooking = bookingInfo && bookingInfo.accommodationBooking && !bookingInfo.itineraryBookings;
    const needCheckHSAOF2 = Odigeo.AB.isHotelStandaloneBooking && (isHSABooking || !!deeplinkToken);
    const widgetLoader = createWidgetLoader({
        findBooking: ['my-trips-with-find-booking', xsellFindBookingFactory],
        myTrips: ['openmytrips', myTripsFactory, {needCheckHSAOF2}],
        checkinStatus: ['checkin-status', checkinStatusFactory],
        checkinMoreinfo: ['checkin-moreinfo', checkinMoreinfoFactory],
        checkinError: ['checkin-error', checkinErrorFactory],
    });
    const autoRefreshConfig = {active: true, tab: product || 'offersAndDiscounts', shouldAvoidTagman: false};
    const seatMapCheckInWidget = {
        execute: Odigeo._.partial(widgetLoader.get('myTrips').execute,
            'executeCheckinFunnelMethod', 'executeSeatMapCheckInContainerMethod', 'executeSeatMapCheckInMethod'),
    };
    const seatMapPaymentCheckInWidget = {
        execute: Odigeo._.partial(widgetLoader.get('myTrips').execute,
            'executeCheckinFunnelMethod', 'executeSeatMapCheckInContainerMethod', 'executeSeatMapPaymentCheckInMethod'),
    };
    const updateSidebarAndTitleComponentsVisibility = function() {
        const hasRememberMeCookie = ssoUtils.hasRememberMeCookie();
        // TODO: Change to (several) execute(s) on widget(s) as soon as the logic and templates are split into smaller widgets!!
        $personalAreaMenu.trigger('changeSelectedMenu', 'mytrips');
        $loggedMenu.toggleClass('odf-hidden', !hasRememberMeCookie);
        $notLoggedMenu.toggleClass('odf-hidden', hasRememberMeCookie);
        widgetLoader.get('findBooking').execute('emptyFindBookings');
    };
    const processBookingInfo = function(bookingInfoUpdated) {
        const {showFlightInfo, showProduct} = urlParams;
        if (showFlightInfo || showProduct) {
            urlParams.showFlightInfo = false;
            switch (product) {
                case postBookingUtils.availableProducts.bags:
                    if (showProduct) {
                        widgetLoader.get('myTrips').execute('scrollToProduct', product);
                    } else {
                        widgets.getPostBookingBags().execute('open');
                        Odigeo.trigger('trip-details:openAddBags', bookingInfoUpdated, Odigeo.Utils.parseJson(ancillaryInfo), true);
                    }
                    break;
                case postBookingUtils.availableProducts.seats:
                    if (showProduct) {
                        widgetLoader.get('myTrips').execute('scrollToProduct', product);
                    } else {
                        widgets.getPostBookingSeats().execute('open');
                        Odigeo.trigger('trip-details:openAddSeats', bookingInfoUpdated, Odigeo.Utils.parseJson(ancillaryInfo), false);
                    }
                    break;
                case postBookingUtils.availableProducts.none:
                    break;
            }
        }
        loadOpenBookingDetails(bookingInfoUpdated);
    };

    const loadOpenBookingDetails = (bookingInfoUpdated) => {
        const selectedTab = Odigeo.AB.isAutoRefresh ? autoRefreshConfig.tab : product;
        const selectedProduct = (actions === 'opencmf') ? 'checkIn' : selectedTab;
        const hasRefreshedFromConfirmation = Odigeo.Utils.parseJson(Odigeo.Session.get('hasRefreshedFromConfirmation'));
        widgetLoader.get('myTrips').execute('loadOpenBookingDetails', {actions, product: selectedProduct, funnel});
        if ((Odigeo.AB.isAutoRefresh && !autoRefreshConfig.shouldAvoidTagman) ||
            (!Odigeo.AB.isAutoRefresh && !hasRefreshedFromConfirmation?.shouldAvoidTagman)) {
            tagManagement.updateAndExtendDatalayer({
                env_template: getTMSTemplate(bookingInfoUpdated),
            }, {
                product: getTMSProduct(bookingInfoUpdated),
            });
        }
        Odigeo.Session.set('hasRefreshedFromConfirmation',
            JSON.stringify({bookingId: hasRefreshedFromConfirmation?.bookingId, shouldAvoidTagman: false}));
        autoRefreshConfig.shouldAvoidTagman = false;
        if (!Odigeo.AB.isAutoRefresh && bookingInfoUpdated) {
            autoRefreshTimeout = myTripsUtils.shouldExecuteRefresh(bookingInfoUpdated.bookingProductStatus, bookingInfoUpdated.bookingBasicInfo?.id,
                deeplinkOrigin, REFRESH_GENERAL_STATUS_TIME);
        }
    };

    const getTMSProduct = (bookingInfo) => {
        if (bookingInfo.accommodationBooking) {
            return bookingInfo.itineraryBookings ? 'dp' : 'accommodation';
        } else {
            return 'flights';
        }
    };

    const getTMSTemplate = (bookingInfo) => {
        const isRedirectionFromConfirmationOF1 = !!Odigeo.Session.get('isRedirectionFromConfirmation');
        const isRedirectionFromConfirmationOF2 = deeplinkOrigin === 'flow';
        const bookingFlow = isRedirectionFromConfirmationOF1 || isRedirectionFromConfirmationOF2 ? 'bf-' : '';
        const bookingType = bookingInfo.accommodationBooking ? (bookingInfo.itineraryBookings ? 'dp' : 'hotel') : 'flights';
        return `${bookingType}-${bookingFlow}tripdetails`;
    };

    const isLoggedInEventHandler = (fallbackNavigation) => {
        const delay = (deeplinkOrigin === 'flow') ?
            parseInt(Odigeo.UserArea.tripDetailsBookingFlowDelay || BOOKING_FLOW_DEFAULT_DELAY) || BOOKING_FLOW_DEFAULT_DELAY: 0;
        const wasDeeplinkProcessed = myTripsUtils.processDeeplink(deeplinkToken, deeplinkTokenOld, delay);
        if (!wasDeeplinkProcessed && Odigeo._.isEmpty(bookingInfo)) {
            Odigeo.Router.navigate(fallbackNavigation);
        }
    };

    $page.removeClass().addClass([
        TRIPDETAILS,
        ...Odigeo.AB.isHotelStandaloneBooking && isHSABooking ? [MANAGE_MY_BOOKING] : [],
    ].join(' '));
    Odigeo.UIElements.menu.enhanceMenu($personalAreaMenu);
    updateSidebarAndTitleComponentsVisibility();

    Odigeo.Router.eventController = $.extend(true, Odigeo.Router.eventController,
        Odigeo.Router.handlers.globalEventController,
        Odigeo.Router.handlers.userEventController,
        postBookingEventController, {
            // Global events will remain bound in any part of the application
            globalEvents: {
                'global:loginOk': 'onLoginOk',
                'global:isLoggedInOk': 'onIsLoggedInOk',
                'global:isLoggedInError': 'onIsLoggedInWithError',
                'global:isLoggedInWithError': 'onIsLoggedInWithError',
                'global:userLogout': 'onLogoutOk',
            },
            viewEvents: {
                'ancillaries:bagsAndSeatsAvailability': 'onBagsAndSeatsAvailability',
                'baggage_wrapper_postbooking:loadBags': 'onLoadBags',
                'baggage_wrapper_postbooking:hideAncillaryCTA': 'hideAncillaryCTA',
                'bags_and_seats_offline:loadBags': 'onLoadBags',
                'seats_wrapper_postbooking:loadSeats': 'onLoadSeats',
                'seats_wrapper_postbooking:hideAncillaryCTA': 'hideAncillaryCTA',
                'seats_wrapper_postbooking:displayPostBookingSeatsOF2Wrapper': 'onDisplayPostBookingSeatsOF2Wrapper',
                'bags_and_seats_offline:loadSeats': 'onLoadSeats',
                'post-booking-bags:bagsAvailable': 'onBagsAvailable',
                'post-booking-seats:seatsAvailable': 'onSeatsAvailable',
                'post-booking-seats:purchaseOk': 'onpurchaseOk',
                'post-booking-bags:purchaseOk': 'onpurchaseOk',
                'users-manager:getEncryptedTripWithError': 'onGetEncryptedTripError',
                'users-manager:getEncryptedTripError': 'onGetEncryptedTripError',
                'users-manager:getEncryptedTripOk': 'onGetEncryptedTripOk',
                'users-manager:getTripWithError': 'onGetAnyTripError',
                'users-manager:getTripError': 'onGetAnyTripError',
                'users-manager:getTripOk': 'onGetTripOk',
                'users-manager:getManageBookingTokenOk': 'onGetManageBookingTokenOK',
                'openmytrips:hideManageMyBookingBox': 'onHideManageMyBookingBox',
                'openmytrips:requestManageMyBookingToken': 'onRequestManageMyBookingToken',
                'openmytrips:my_trips_details_loaded': 'onMyTripsDetailsLoaded',
                'seatmap-checkin:moveToSeatSelectionCheckIn': 'onMoveToSeatSelectionCheckIn',
                'seatmap-checkin:moveToSeatPaymentCheckIn': 'onMoveToSeatPaymentCheckIn',
                'aircraftmap-checkin:moveToSeatPaymentCheckIn': 'onMoveToSeatPaymentCheckIn',
                'seatmap-checkin-container:seatsAvailable': 'onSeatsAvailableCheckIn',
                'seatmap-checkin-container:moveToSeatMapSelectionCheckIn': 'moveToSeatMapSelectionCheckIn',
                'seatmap-checkin-container:closeAircraftMap': 'onCloseAircraftMapDesktopCheckIn',
                'seatmap-checkin-container:purchaseOk': 'onSeatmapCheckinContainerPurchaseOk',
                'seatmap-checkin-container:purchaseError': 'onSeatmapCheckinContainerPurchaseError',
                'seatmap-checkin-container:purchasePaymentError': 'onSeatmapCheckinContainerPurchaseError',
                'seatmap-checkin-container:moveToCheckinStep': 'onSeatmapCheckinContainerMoveToCheckinStep',
                'seatmap-checkin-container:seatmapCheckinGenericErrorClose': 'onSeatmapCheckinGenericError',
                'aircraftmap_manager:updateSeatSelectionFeesCheckIn': 'onUpdateSeatSelectionFeesCheckIn',
                'aircraftmap_manager:tapNavigateButtonCheckIn': 'onTapAircraftMapNavigateButtonCheckIn',
                'aircraftmap_manager:closeAircraftMapCheckIn': 'onCloseAircraftMapDesktopCheckIn',
                'seatmap-payment-checkin:cardDataChanged': 'onCardDataChangedCheckIn',
                'seatmap-payment-checkin-bin-detection:creditCardTypeCodeChanged': 'onCreditCardTypeCodeChangedCheckIn',
                'one-click-checkout-checkin-payment-form:cardDataChanged': 'onCardDataChangedCheckIn',
                'one-click-checkout-checkin-insurance-payment-form:cardDataChanged': 'onCardDataChangedCheckInPayment',
                'one-click-checkout-checkin-bin-detection:creditCardTypeCodeChanged': 'onCreditCardTypeCodeChangedCheckIn',
                'one-click-checkout-checkin:onCheckoutConfirm': 'onSeatmapCheckinContainerPurchaseOk',
                'one-click-checkout-checkin:genericError': 'onSeatmapCheckinContainerPurchaseError',
                'one-click-checkout-checkin:onCheckoutPaymentRetry': 'onSeatmapCheckinContainerPurchaseError',
                'one-click-checkout-checkin:onCheckoutInteractionNeeded': 'onCheckinMFCheckoutInteractionNeeded',
                'one-click-checkout-checkin:onCheckoutInteractionNeededClosed': 'onCheckinMFCheckoutInteractionNeededClosed',
                'one-click-checkout-checkin-insurance:onCheckoutConfirm': 'onProductCheckinContainerPurchaseOk',
                'one-click-checkout-checkin-insurance:onCheckoutPaymentRetry': 'onProductCheckinContainerPurchaseError',
                'one-click-checkout-checkin-insurance:genericError': 'onProductCheckinContainerPurchaseError',
                'one-click-checkout-checkin-insurance:onCheckoutInteractionNeeded': 'onProductCheckinCheckoutInteractionNeeded',
                'one-click-checkout-checkin-insurance:onCheckoutInteractionNeededClosed': 'onProductCheckinCheckoutInteractionNeededClosed',
                'one-click-checkout-checkin-insurance-bin-detection:creditCardTypeCodeChanged': 'creditCardTypeCodeChangedInsurance',
                'insurance-payment-container:productCheckinGenericErrorClose': 'onProductCheckinGenericError',
                'insurance-payment-container:moveToCheckinStep': 'onProductPaymentContainerMoveToCheckinStep',
                'checkin_funnel:closeCheckInFunnel': 'onCloseCheckInFunnel',
                'checkin_funnel:toggleCheckinOptionMoreInfoDone': 'onToggleCheckinOptionMoreInfoDone',
                'checkin_funnel:toggleCheckinOptionRequestError': 'onToggleCheckinOptionRequestError',
                'checkin_funnel:checkinStatusDone': 'onCheckinStatusDone',
                'checkin_moreinfo:startCheckinFunnelPopup': 'onStartCheckinFunnelPopup',
                'itinerary_status_changed_alert:onLoadWidgetTripDetailsTracking': 'onLoadWidgetTripDetailsTracking',
                'open_ticket:hideFlightStatusMessage': 'onHideFlightStatusMessage',
                'open_ticket:showFlightStatusMessage': 'onShowFlightStatusMessage',
                'trip_details:toggleDownloadAppNotification': 'onToggleDownloadAppNotification',
                'modifications_status_notification_manager:toggleDownloadAppNotification': 'onToggleDownloadAppNotification',
                'frontend-shell:CMF:enable-continue-button': 'onEnableContinueButtonFromCMF',
                'frontend-shell:CMF:continue-from-insurance-step': 'onContinueFromInsuranceStepInCMF',
                'frontend-shell:CMF:return-mytrips-button': 'onCmfErrorCloseButton',
                'frontend-shell:CMF:click-insurance-radio': 'onClickInsuranceRadioInCMF',
                'insurance_payment_container:returnToInsuranceStep': 'returnToInsuranceStep',
                'frontend-shell:CMF:tracking': 'onCmfTracking',
                'frontend-shell:checkinScenario': 'onCheckinScenario',
                'frontend-shell:openCheckinFunnel': 'onStartCheckinFunnelPopup',
                'frontend-shell:closeCheckinFunnel': 'onCloseCheckInFunnelOF2',
                'frontend-shell:openOldMMB': 'onOpenMmbOf1',
                'frontend-shell:openMMB': 'onOpenMmbOf2',
                'frontend-shell:openMMBCancellations': 'onOpenMMBCancellations',
                'frontend-shell:goToProduct': 'onGoToProduct',
                'frontend-shell:refreshByChangeBooking': 'onRefreshTripDetails',
                'frontend-shell:openBagsAndSeatsPopup': 'onOpenSeatsAndBagsPopup',
                'involuntary_cancellation:openNewAlternativesFlow': 'onOpenNewAlternativesFlow',
                'my-trips:selectedTab': 'onSelectedTab',
                'checkin:loadedScenario': 'onLoadedCheckinScenario',
            },
            eventHandlers: {
                onEnableContinueButtonFromCMF() {
                    widgetLoader.get('myTrips').execute('executeCheckinFunnelMethod', 'enableContinueButton');
                },
                onClickInsuranceRadioInCMF({yesInsuranceRadio} = {}) {
                    widgetLoader.get('myTrips')
                        .execute('executeCheckinFunnelMethod', 'clickInsuranceRadioinCmf', {
                            yesInsuranceRadio,
                        });
                },
                onContinueFromInsuranceStepInCMF({products = [], shoppingBasketId, userHasSelectedOption, yesInsuranceRadio} = {}) {
                    widgetLoader.get('myTrips')
                        .execute('executeCheckinFunnelMethod', 'progressStep', {
                            skipNextStep: products.length === 0,
                            fromShell: true,
                            shoppingBasketId,
                            userHasSelectedOption,
                            yesInsuranceRadio,
                        });
                },
                onCmfTracking(data) {
                    widgetLoader.get('myTrips').execute('executeCheckinFunnelMethod', 'onTracking', data);
                },
                onCmfErrorCloseButton() {
                    widgetLoader.get('myTrips').execute('executeCheckinFunnelMethod', 'closeCMFGenericErrorInsurance');
                },
                onMoveToSeatSelectionCheckIn() {
                    widgetLoader.get('myTrips').execute('dispatchSeatMapCheckInAction', 'moveToSeatSelectionCheckIn');
                },
                onMoveToSeatPaymentCheckIn(source) {
                    widgetLoader.get('myTrips').execute('dispatchSeatMapCheckInAction', 'moveToSeatPaymentCheckIn', source);
                },
                onLoginOk(data) {
                    $('#myInfoUserName').text(data.displayName ? data.displayName : '');
                    myTripsUtils.saveDeeplinksInSession(deeplinkToken, deeplinkTokenOld);
                    updateSidebarAndTitleComponentsVisibility();
                    Odigeo._.defer(Odigeo._.bind(Odigeo.Router.navigate, Odigeo.Router), 'mytrips');
                },
                onLogoutOk() {
                    updateSidebarAndTitleComponentsVisibility();
                    Odigeo.Utils.goToApplicationHome();
                },
                onIsLoggedInOk() {
                    isLoggedInEventHandler('mytrips');
                },
                onIsLoggedInWithError() {
                    isLoggedInEventHandler('mytripslogin');
                },
                onLoadBags(bookingInfo) {
                    widgets.getPostBookingBags().execute('open');
                    pbAncillariesCollection.loadTripBags(bookingInfo);
                },
                onLoadSeats(bookingInfo) {
                    widgets.getPostBookingSeats().execute('open');
                    pbAncillariesCollection.loadTripSeats(bookingInfo);
                },
                onBagsAndSeatsAvailability(response) {
                    myTripsUtils.setBagsAndSeatsLoaded(response);
                    if (myTripsUtils.isLoadedBagsAndSeats()) {
                        widgetLoader.get('myTrips').execute('showBagsAndSeatsMoreInfoLink', myTripsUtils.getBagsAndSeatsLoaded());
                    }
                },
                hideAncillaryCTA(type) {
                    widgetLoader.get('myTrips').execute('hideAncillaryCTA', type);
                },
                onDisplayPostBookingSeatsOF2Wrapper() {
                    widgetLoader.get('myTrips').execute('displayPostBookingSeatsOF2Wrapper');
                },
                onBagsAvailable(ancillaryInfo) {
                    const bookingInfo = Odigeo.Utils.parseJson(Odigeo.Session.get(BOOKING_INFO));
                    Odigeo.Session.set('ancillaryInfo', JSON.stringify(ancillaryInfo.availableAncillariesOptionsDTO));
                    Odigeo.trigger('trip-details:openAddBags', bookingInfo, ancillaryInfo.availableAncillariesOptionsDTO, false);
                    if (actions === 'openbags') {
                        widgetLoader.get('myTrips').execute('openPopupStartup', 'bags');
                    }
                },
                onSeatsAvailable(ancillaryInfo) {
                    const bookingInfo = Odigeo.Utils.parseJson(Odigeo.Session.get(BOOKING_INFO));
                    Odigeo.Session.set('ancillaryInfo', JSON.stringify(ancillaryInfo.availableAncillariesOptionsDTO));
                    Odigeo.trigger('trip-details:openAddSeats', bookingInfo, ancillaryInfo.availableAncillariesOptionsDTO, false);
                    if (actions === 'openseats') {
                        widgetLoader.get('myTrips').execute('openPopupStartup', 'seats');
                    }
                },
                onOpenSeatsAndBagsPopup({product}) {
                    widgetLoader.get('myTrips').execute('openBagsAndSeatsPopup', {product});
                },
                onpurchaseOk(type) {
                    const bookingInfo = Odigeo.Utils.parseJson(Odigeo.Session.get(BOOKING_INFO));
                    const data = {};
                    myTripsUtils.showPopUpPurchaseOk(type);
                    data.email = bookingInfo.buyer.mail;
                    data.bookingid = bookingInfo.bookingBasicInfo.id;
                    myTripsUtils.requestTrip(data);
                },
                onGetAnyTripError() {
                    myTripsUtils.handleTripError();
                },
                onGetTripOk({bookingDetailDTO}) {
                    tripdetailsStorageUtils.setInSessionWithExpirationTime(BOOKING_INFO, bookingDetailDTO);
                    processBookingInfo(bookingDetailDTO);
                },
                onGetEncryptedTripOk({bookingDetailDTO}) {
                    tripdetailsStorageUtils.setInSessionWithExpirationTime(BOOKING_INFO, bookingDetailDTO);
                    tripdetailsStorageUtils.setRedirectFromConfirmation(deeplinkOrigin, bookingDetailDTO.bookingBasicInfo.id);
                    myTripsUtils.deepLinkTracking(params, true);
                    processBookingInfo(bookingDetailDTO);
                },
                onGetEncryptedTripError({email, bookingId}) {
                    myTripsUtils.deepLinkTracking(params, false);
                    if (deeplinkOrigin === 'flow') {
                        tripdetailsStorageUtils.setInSessionWithExpirationTime(BOOKING_INFO, {
                            bookingBasicInfo: {
                                id: bookingId,
                            },
                            buyer: {mail: email},
                            forceReload: true,
                        });
                        widgetLoader.get('myTrips').execute('confirmationBackup');
                    } else {
                        myTripsUtils.handleTripError();
                    }
                },
                onHideManageMyBookingBox() {
                    $manageMyBookingBox.addClass('odf-hidden');
                },
                onRequestManageMyBookingToken(data) {
                    widgets.getUsersManager().execute('submitUserRequest', {
                        'data': data,
                        'action': 'getManageBookingToken',
                    });
                },
                onGetManageBookingTokenOK(data) {
                    if (!Odigeo._.isEmpty(data.token)) {
                        widgetLoader.get('myTrips').execute('showManageMyBookingBox', data, actions === 'openmmb', funnel);
                    }
                },
                onSeatsAvailableCheckIn(ancillaryInfo) {
                    const bookingInfo = Odigeo.Utils.parseJson(Odigeo.Session.get(BOOKING_INFO));
                    const bookingId = bookingInfo.bookingBasicInfo.id;
                    const collectionMethods = postBookingUtils.getCollectionMethods(ancillaryInfo);
                    const acceptedCreditCardTypeCodes = postBookingUtils.getCreditCardTypeCodes(collectionMethods);
                    seatMapPaymentCheckInWidget.execute('setPaymentOptions', bookingId, collectionMethods, acceptedCreditCardTypeCodes);
                    seatMapCheckInWidget.execute('loadFromParameters', bookingInfo, ancillaryInfo, 'checkin');
                },
                moveToSeatMapSelectionCheckIn(ancillaryInfo) {
                    const bookingInfo = Odigeo.Utils.parseJson(Odigeo.Session.get(BOOKING_INFO));
                    seatMapCheckInWidget.execute('moveToSeatMapSelectionCheckIn', bookingInfo, ancillaryInfo);
                },
                onUpdateSeatSelectionFeesCheckIn() {
                    seatMapCheckInWidget.execute('updateSeatSelectionFees');
                },
                onTapAircraftMapNavigateButtonCheckIn(flightDetails, step, aircraftOptions) {
                    seatMapCheckInWidget.execute('onTapNavigateButton', flightDetails, step, aircraftOptions);
                },
                onCloseAircraftMapDesktopCheckIn(source) {
                    seatMapCheckInWidget.execute('onCloseAircraftMap', source);
                },
                onSeatmapCheckinContainerPurchaseOk() {
                    widgetLoader.get('myTrips').execute(
                        'dispatchSeatMapCheckInAction', 'seatPaymentOk');
                },
                onSeatmapCheckinContainerPurchaseError() {
                    widgetLoader.get('myTrips').execute(
                        'dispatchSeatMapCheckInAction', 'seatPaymentError');
                },
                onCheckinMFCheckoutInteractionNeeded() {
                    widgetLoader.get('myTrips').execute(
                        'dispatchSeatMapCheckInAction', 'toggleLightboxTransform', true);
                },
                onCheckinMFCheckoutInteractionNeededClosed() {
                    widgetLoader.get('myTrips').execute(
                        'dispatchSeatMapCheckInAction', 'toggleLightboxTransform', false);
                },
                onSeatmapCheckinGenericError() {
                    widgetLoader.get('myTrips').execute(
                        'dispatchSeatMapCheckInAction', 'closeCheckinFunnel');
                },
                onSeatmapCheckinContainerMoveToCheckinStep() {
                    widgetLoader.get('myTrips').execute(
                        'dispatchSeatMapCheckInAction', 'progressStep', {hasSeatsPurchased: true});
                },
                onProductPaymentContainerMoveToCheckinStep() {
                    widgetLoader.get('myTrips').execute('executeCheckinFunnelMethod', 'progressStep');
                },
                onProductCheckinContainerPurchaseOk() {
                    widgetLoader.get('myTrips').execute('dispatchProductCheckInAction', 'productPaymentOk');
                },
                onProductCheckinContainerPurchaseError() {
                    widgetLoader.get('myTrips').execute('dispatchProductCheckInAction', 'productPaymentError');
                },
                onProductCheckinGenericError() {
                    widgetLoader.get('myTrips').execute('dispatchProductCheckInAction', 'closeCheckinFunnel');
                },
                onProductCheckinCheckoutInteractionNeeded() {
                    widgetLoader.get('myTrips').execute('dispatchProductCheckInAction', 'toggleLightboxTransform', true);
                },
                onProductCheckinCheckoutInteractionNeededClosed() {
                    widgetLoader.get('myTrips').execute('dispatchProductCheckInAction', 'toggleLightboxTransform', false);
                },
                onCreditCardTypeCodeChangedCheckIn(creditCardTypeCode, creditCardTypeName) {
                    widgetLoader.get('myTrips').execute(
                        'dispatchSeatMapCheckInAction', 'setCreditCardTypeCodeCheckin',
                        creditCardTypeCode);
                    seatMapPaymentCheckInWidget.execute('setCreditCardTypeCode', creditCardTypeCode, creditCardTypeName);
                },
                onCardDataChangedCheckIn(isValid, paymentDetails) {
                    widgetLoader.get('myTrips').execute(
                        'dispatchSeatMapCheckInAction', 'updatePaymentButtonCheckIn',
                        isValid, paymentDetails);
                },
                onCardDataChangedCheckInPayment(isValid, paymentDetails) {
                    widgetLoader.get('myTrips').execute(
                        'dispatchSeatMapCheckInAction', 'updateInsurancePaymentDetails',
                        isValid, paymentDetails);
                },
                returnToInsuranceStep() {
                    widgetLoader.get('myTrips').execute('dispatchSeatMapCheckInAction', 'returnToInsuranceStep');
                },
                onCloseCheckInFunnel(isCheckInStatusContainerShown) {
                    widgetLoader.get('myTrips').execute('setTripCardCheckInButtonVisibility', isCheckInStatusContainerShown);
                },
                onCheckinStatusDone(show) {
                    widgetLoader.get('checkinStatus').execute('showCheckinStatus', show);
                },
                onToggleCheckinOptionMoreInfoDone(show) {
                    widgetLoader.get('checkinMoreinfo').execute('showCheckinMoreInfo', show);
                },
                onToggleCheckinOptionRequestError(show) {
                    widgetLoader.get('checkinError').execute('showCheckinError', show);
                },
                onStartCheckinFunnelPopup() {
                    const $checkinTab = $page.find('.smt_tab_selector[data-content-keyword="checkIn"]');
                    if (!$checkinTab.hasClass('active')) {
                        $checkinTab.trigger('tap');
                    }
                    widgetLoader.get('myTrips').execute('startCheckinFunnelPopup');
                    if (Odigeo.AB.isAutoRefresh) {
                        autoRefreshConfig.active = false;
                    } else {
                        myTripsUtils.pauseAutoRefresh(autoRefreshTimeout);
                    }
                },
                onOpenMmbOf1() {
                    widgetLoader.get('myTrips').execute('openMmbOf1');
                },
                onOpenMmbOf2() {
                    widgetLoader.get('myTrips').execute('openMmbOf2');
                },
                onOpenMMBCancellations() {
                    widgetLoader.get('myTrips').execute('navigateToMMBCancellationsHSA');
                },
                onOpenNewAlternativesFlow() {
                    widgetLoader.get('myTrips').execute('openNewAlternativesFlow');
                },
                onGoToProduct({product, mail, bookingId, touchpoint}) {
                    manageMyBookingModule.openDeepLinkByProduct(product, bookingId, mail, touchpoint);
                },
                onMyTripsDetailsLoaded() {
                    widgets.getUsersManager().get('getUserDTO').then((userDTO) => {
                        if (userDTO) {
                            const {buyer: {prime = false} = {}} = Odigeo.Utils.parseJson(Odigeo.Session.get(BOOKING_INFO)) || {};
                            widgetLoader.get('myTrips').execute('setIsPrimeUser', prime);
                            widgetLoader.get('myTrips').execute('setPrimeExpirationDate', prime
                                ? new Date(Odigeo._.get(userDTO, 'membershipInfoDTO.membershipDTO.expirationDate')).getTime()
                                : null);
                        }
                    });
                },
                onLoadWidgetTripDetailsTracking(data) {
                    itineraryStatusTracking.trackItineraryStatusOnLoad(data.bookingInfo, data.changedPNRs, data.airlineList);
                },
                onHideFlightStatusMessage() {
                    widgetLoader.get('myTrips').execute('hideFlightStatusMessage');
                },
                onShowFlightStatusMessage() {
                    widgetLoader.get('myTrips').execute('showFlightStatusMessage');
                },
                onToggleDownloadAppNotification() {
                    widgetLoader.get('myTrips').execute('toggleDownloadAppNotification');
                },
                creditCardTypeCodeChangedInsurance(creditCardTypeCode, creditCardTypeName) {
                    widgetLoader.get('myTrips')
                        .execute('executeCheckinFunnelMethod', 'updateCreditCardType', {creditCardTypeCode, creditCardTypeName} );
                },
                onCloseCheckInFunnelOF2() {
                    widgetLoader.get('myTrips').execute('closeCheckinFunnelOF2');
                    if (!Odigeo.AB.isAutoRefresh) {
                        const bookingInfo = Odigeo.Utils.parseJson(Odigeo.Session.get(BOOKING_INFO));
                        myTripsUtils.shouldExecuteRefresh(bookingInfo?.bookingProductStatus, bookingInfo.bookingBasicInfo?.id,
                            deeplinkOrigin, REFRESH_GENERAL_STATUS_TIME);
                    } else if (!autoRefreshConfig.active) {
                        autoRefreshConfig.active = true;
                        this.onRefreshTripDetails();
                    }
                },
                onCheckinScenario(scenario) {
                    widgetLoader.get('myTrips').execute('checkinScenario', scenario);
                },
                onRefreshTripDetails() {
                    if (Odigeo.AB.isAutoRefresh && autoRefreshConfig.active) {
                        const bookingInfo = Odigeo.Utils.parseJson(Odigeo.Session.get(BOOKING_INFO));
                        autoRefreshConfig.shouldAvoidTagman = true;
                        myTripsUtils.requestTrip({
                            email: bookingInfo.buyer.mail,
                            bookingid: bookingInfo.bookingBasicInfo.id,
                        });
                        $('html').animate({scrollTop: 0}, 500, 'swing');
                        trackingUtils.trackEventWithCategory('my_area_trips_details', 'reload-widgets', 'booking-status-changed_pag:tripdetails');
                    }
                },
                onSelectedTab(tabSelected) {
                    autoRefreshConfig.tab = tabSelected;
                },
                onLoadedCheckinScenario(isShowCheckinButton) {
                    if (isShowCheckinButton && actions === 'openCheckin') {
                        widgetLoader.get('myTrips').execute('openTripCheckinFunnelPopup');
                    }
                },
            },
        });
    Odigeo.Router.eventController.execute();

    widgetLoader.get('myTrips');

    postBookingEventController.init();

    if (Odigeo._.isEmpty(deeplinkToken) && Odigeo._.isEmpty(deeplinkTokenOld)) {
        if (isValidBookingInfo) {
            processBookingInfo(bookingInfo);
        } else {
            myTripsUtils.notValidBookingInfoHandler(bookingInfo);
        }
    } else {
        if (deeplinkOrigin === 'mytripslogin') {
            myTripsUtils.processDeeplink(deeplinkToken);
            let params = new URLSearchParams(location.search);
            params.delete('origin');
            window.history.replaceState(null, '', '?' + params + location.hash);
        }
    }

    Odigeo.once('routeChange', () => {
        if (Odigeo.AB.isManageMyBookingDesktop) {
            $manageMyBookingBox.addClass('odf-hidden');
        }
    });

    const reactivateScrollY = () => {
        const lightBoxEl = document.querySelector('#tripdetails .new_manage_my_booking_lightbox');
        if (lightBoxEl?.classList.contains('open')) {
            lightBoxEl.classList.remove('open');
            lightBoxEl.style.overflowY = 'auto';
            document.body.style.overflowY = 'auto';
        }
    };

    Odigeo.on('routeChange', function isMmbInternalNavigation({from, to}) {
        if (!to.name.includes('tripdetails')) {
            reactivateScrollY();
            Odigeo.off('routeChange', isMmbInternalNavigation);
            getFrontendBookingManagement().then((bookingManagement) => {
                const containers = document.querySelectorAll('.conchita.conchita-container');
                containers.forEach((element) => bookingManagement.unmountComponentAtNode(element));
            });
        }
    });
};
